<template lang="pug">
	#sfc-main-container
		sfc-menu
		#sfc-main-content
			nuxt
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'
	>>> #nav_collapse
		display: none !important
	>>> .non-collapse
		display: none !important
	>>> .collapses
		margin-top: 20px

	>>> .nav-row > .row
		max-width: 100% !important
</style>

<script>
import SfcMenu from '@/layouts/common/sfc-menu-slim-v2'
export default {
	components:{
		SfcMenu
	},
	data(){
		return{
		}

	}
}
</script>
